import { useTranslation } from "react-i18next";
import { RubricRuleset } from "./types";
import { SUPPORTED_CHECK_TYPES } from "../../pages/adjudication/constants";
import { SectionMessage } from "@certn/cascadia-react";
import { hasInvalidCriteria } from "./utils";

type Props = {
  selectedRuleset: RubricRuleset;
};

export function PreviewRubricErrorSectionMessage({ selectedRuleset }: Props) {
  const { t } = useTranslation();

  const getErrorMessage = () => {
    if (!SUPPORTED_CHECK_TYPES.includes(selectedRuleset.check_type)) {
      return t("This check type is not supported for preview");
    }

    if (hasInvalidCriteria(selectedRuleset)) {
      return t(`Invalid criteria for check type: {{checkType}}`, {
        checkType: selectedRuleset.check_type,
      });
    }

    return t("Unknown error occurred");
  };

  return (
    <SectionMessage
      type="danger"
      icon="warning"
      sectionTitle={t("Unable to preview scoring rubric")}
    >
      {getErrorMessage()}
    </SectionMessage>
  );
}
